import { EXAM_BY_ID } from "../data/exams";
import { questionsForExam } from "../data/questions";
import type { ExamId } from "../data/types";
import type { Progress } from "./progress";
import { scaledScore } from "./scoring";
import { isMastered } from "./srs";

export interface Mastery {
  total: number;
  seen: number;
  mastered: number;
  /** Tỉ lệ đúng ở lần trả lời gần nhất của các câu đã gặp (0–1). */
  accuracy: number;
}

function tally(ids: string[], p: Progress): Mastery {
  let seen = 0;
  let mastered = 0;
  let lastRight = 0;
  for (const id of ids) {
    const s = p.questions[id];
    if (!s) continue;
    seen++;
    if (s.lastCorrect) lastRight++;
    if (isMastered(s.srs)) mastered++;
  }
  return { total: ids.length, seen, mastered, accuracy: seen ? lastRight / seen : 0 };
}

export function examMastery(examId: ExamId, p: Progress): Mastery {
  return tally(questionsForExam(examId).map((q) => q.id), p);
}

export function domainMastery(examId: ExamId, domainId: string, p: Progress): Mastery {
  return tally(questionsForExam(examId).filter((q) => q.domain === domainId).map((q) => q.id), p);
}

/**
 * Điểm sẵn sàng ước tính (100–1000): trung bình có trọng số độ chính xác theo domain,
 * nhân với độ phủ (câu chưa gặp coi như sai). Trả null nếu chưa đủ dữ liệu.
 */
export function readiness(examId: ExamId, p: Progress): number | null {
  const exam = EXAM_BY_ID[examId];
  const overall = examMastery(examId, p);
  if (overall.seen < Math.min(5, overall.total)) return null;
  const equal = 100 / exam.domains.length;
  let weighted = 0;
  let weightSum = 0;
  for (const d of exam.domains) {
    const m = domainMastery(examId, d.id, p);
    if (!m.total) continue;
    const w = d.weight ?? equal;
    const coverage = m.seen / m.total;
    weighted += w * m.accuracy * coverage;
    weightSum += w;
  }
  if (!weightSum) return null;
  return scaledScore(weighted / weightSum, 1);
}
